import UrunlerService from "../../../services/UrunlerService";

export default {
  namespaced: true,
  state: () => ({
    urunListesiDuzenle: {},
    urunListeleri: [],
    listeDetay: {},
  }),
  mutations: {
    setUrunListeleri: (state, data) => {
      state.urunListeleri = data;
    },
    setDuzenle: (state, data) => {
      state.urunListesiDuzenle = data;
    },
    setListeDetay: (state, data) => {
      state.listeDetay = data;
    },
  },
  actions: {
    /**
     * Ürün listelerinin listesini getirir
     * @param {*} param0
     */
    urunListeleri: ({ commit }) => {
      return new Promise((resolve, reject) => {
        UrunlerService.urunListeleri()
          .then((res) => {
            commit("setUrunListeleri", res.data);
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    /**
     * Herhangi bir ürün listesinin detayını verir
     *
     * @param {*} param0
     * @param {Number} listeID
     */
    urunListeDetay: ({ commit }, listeID) => {
      return new Promise((resolve, reject) => {
        UrunlerService.urunListeDetay(listeID)
          .then((res) => {
            commit("setListeDetay", res.data);
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    urunListeEkle: ({ dispatch }, listeData) => {
      return new Promise((resolve, reject) => {
        UrunlerService.urunListeEkle(listeData)
          .then((res) => {
            dispatch("urunListeleri");
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    urunListeGuncelle: ({ dispatch, commit }, listeData) => {
      return new Promise((resolve, reject) => {
        UrunlerService.urunListeGuncelle(listeData)
          .then((res) => {
            if (res.status === 200) {
              dispatch("urunListeleri");
              commit("setListeDetay", []);
            }
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    urunListeKaldir: ({ dispatch }, listeID) => {
      return new Promise((resolve, reject) => {
        UrunlerService.urunListeKaldir(listeID)
          .then((res) => {
            dispatch("urunListeleri");
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    setListeSiralama: ({ dispatch }, listeSiralamasi) => {
      return new Promise((resolve, reject) => {
        UrunlerService.setListeSiralama(listeSiralamasi)
          .then((res) => {
            dispatch("urunListeleri");
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
  },
};
